import { defineMessages } from 'react-intl';

export const usageNudgeCardMessages = defineMessages({
  almostReachedTitle: {
    defaultMessage: 'Almost reached usage limit',
    id: 'JY+BoK04lG',
    description:
      'Sidebar usage card title once a member has used 90% of this cycle’s usage',
  },
  reachedTitle: {
    defaultMessage: 'Reached usage limit',
    id: '5cEUAGzeX2',
    description:
      'Sidebar usage card title once a member has used all of this cycle’s usage',
  },
  limitResets: {
    defaultMessage: 'Limit resets on {date}.',
    id: 'ZDtQbAd1gH',
    description: 'Sidebar usage card body; date is when the member’s usage resets',
  },
  learnMore: {
    defaultMessage: 'Learn more',
    id: 'YsZwslt+++',
    description: 'Link on the sidebar usage card to the usage limits article',
  },
  upgrade: {
    defaultMessage: 'Upgrade',
    id: 'cUjiIfQ2RF',
    description: 'Sidebar usage card button that opens the seat upgrade checkout',
  },
  requestUpgrade: {
    defaultMessage: 'Request to upgrade',
    id: 'm+hgNIpRaF',
    description:
      'Sidebar usage card button for a Practice member to ask their admin for a Max seat',
  },
  close: {
    defaultMessage: 'Close',
    id: 'VFh1EW9vwD',
    description: 'Accessible label of the close button on the sidebar usage card',
  },
});
